import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const DisclaimerWrapper = styled.div`
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  @media (${mediaQuery.mobile}) {
    font-size: 12px;
    line-height: 18px;
  }
  color: #697684;
  word-break: break-word;
`;
